
import link from './css/link-solid-full.svg';
import entropy from './css/EntrophySliding.png';
import { Link } from 'react-router-dom'
import ScrollStack, { ScrollStackItem } from './ScrollStack'



export default function Home() {
return (
    <div className='content-projects'>
        <div className="project-card">  
            <div className='card-container-left pd-20'>

                <h2>Malware Classifier</h2>
                <div className="card-container-links">
                    <Link to={"https://github.com/FrezeeOfficial/Binary-Malware-Classification"}><a>Github<img src={link} alt={"link"}/></a></Link>
                    <Link to={"https://github.com/FrezeeOfficial/Binary-Malware-Classification/blob/main/Final%20Document.pdf"}><a>Publication<img src={link} alt={"link"}/></a></Link>

                    
                </div>



                <p>Custom machine learning algorithm implemented in C++ and Python to classify PE files.</p>
                <p>Extracted and presented features as images, which CNN’s could be trained on</p>
                <p>Trained and tested on various state of the art architectures using the Microsoft BIG 2015 dataset, finally setting on VGG-16</p>
                
                
                
                <ul className="container-card-skills">
                    <li>C++</li>
                    <li>Python</li>
                    <li>Big Data</li>
                    <li>PyTorch</li>
                    <li>Multithreading</li>
                </ul>
            </div>

            {/* <div className="card-container-right">
                <img src={entropy} alt={"image of entropy visualised in malware"}/>
            </div> */}
        </div>

        <div className="project-card">  
            <div className='card-container-left'>

                <h2>Custom FF Neural Network</h2>
                <div className="card-container-links">
                    <a>Github<img src={link} alt={"link"}/></a>
                </div>



                <p>Implemented a fully custom feed-forward neural network in C++ from scratch, including gradient descent and backpropagation without external ML libraries.
                </p>
                <p>Designed, trained, and tested the network to handle binary input data, focusing on efficiency, correctness, and extensibility of the implementation.</p>
                <ul className="container-card-skills">
                    <li>C++</li>
                    <li>Custom Math Library</li>
                    <li>Multithreading</li>
                </ul>
            </div>

            
        </div>

        <div className="project-card">  
            <div className='card-container-left'>

                <h2>Live Weather Station</h2>
                <div className="card-container-links">
                    <Link to={"https://github.com/FrezeeOfficial/goring_wind"}><a>Github<img src={link} alt={"link"}/></a></Link>
                </div>



                <p>Built a live, map-based GUI showing real-time weather data from local weather station, alongside forecasts from Met Office API.</p>
                <p>Built using react for a progressive web app, fetching data from a backend Express service. Handled api from frontend and weather station.</p>
                <ul className="container-card-skills">
                    <li>Rest</li>
                    <li>Express.js</li>
                    <li>JavaScript</li>
                    <li>React.js</li>
                    <li>HTML/CSS</li>
                </ul>

            </div>

            
        </div>


        <div className="project-card">  
            <div className='card-container-left'>

                <h2>Live Chat Forum</h2>
                <div className="card-container-links">
                    <Link to={"https://github.com/FrezeeOfficial/CSC348"}><a>Github<img src={link} alt={"link"}/></a></Link>
                </div>



                <p>Designed and developed a real-time chat forum using Laravel (PHP, Sail, Docker) with a MySQL database,
                implementing secure user authentication and role-based access.
                </p>
                <p>Build responsive front-end interface with React, JavaScript, and HTML/CSS, ensuring smooth user experience.
                · Applied object-oriented programming principles to structure reusable react components and improve
                maintainability</p>

                <p>Wrote and optimized SQL structure and queries for efficiency data retrieval and storage
                · Delivered the project end-to-end, from technical specifications through to deployment following agile style
                iterations</p>

                <ul className="container-card-skills">
                    <li>React.js</li>
                    <li>Laravel</li>
                    <li>PHP</li>
                    <li>SQL</li>
                    <li>HTML/CSS</li>
                    <li>Docker</li>

                </ul>

            </div>

            
        </div>
        

    </div>
    )
}

